import SearchAutoSuggestComponent from '../../components/autocomplete/SearchAutoSuggest';
import { palette } from '../../theme/palette';
import { SearchIcon } from '../../components/location-modal/LocationModalStyle';
import { styled } from '@mui/material';

export const SearchAutoSuggest = styled(SearchAutoSuggestComponent, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{
  isActive?: boolean;
}>`
  border-radius: 5px;
  border: ${(props) => (props.isActive ? `1px solid ${palette.primary.main}` : `1px solid #ccc`)};
  &:hover {
    border-color: ${palette.primary.main};
  }
  padding-left: 35px;
  height: 40px;
  width: 100%;
  .autocomplete-start-icon-container {
    width: 48px;
  }
`;

export const StyleSearchAutoSuggestIcon = styled(SearchIcon)`
  color: ${palette.primary.main};
  width: 17px;
  cursor: pointer;
`;
